import React from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';

function getColor(pct) {
  if (pct > 100) return '#C62828';
  if (pct >= 80) return '#F9A825';
  return '#2E7D32';
}

export default function ProgressBar({ value, max }) {
  const pct = max > 0 ? (value / max) * 100 : 0;
  const clampedPct = Math.min(pct, 100);
  const color = getColor(pct);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
      <LinearProgress
        variant="determinate"
        value={clampedPct}
        sx={{
          flex: 1,
          height: 8,
          borderRadius: 4,
          bgcolor: '#E6E9EE',
          '& .MuiLinearProgress-bar': { bgcolor: color, borderRadius: 4 },
        }}
      />
      <Box
        component="span"
        sx={{ fontSize: 12, fontWeight: 600, color, minWidth: 40, textAlign: 'right' }}
      >
        {Math.round(pct)}%
      </Box>
    </Box>
  );
}
